import { PropsWithChildren, ReactNode } from 'react'

import { Checkbox, CheckboxProps, Box, Flex } from '@sequencehq/core-components'
import { CollapsibleArea, CollapsibleToggle } from 'Invoices/components'

type Props = {
  children: ReactNode
  toggles?: ReactNode[]
  isVisible: boolean
  setIsVisible: (value: boolean) => void
}

const SecondaryOptionsComponent = ({
  children,
  toggles,
  isVisible,
  setIsVisible
}: Props) => (
  <Flex flexDir="column">
    <Flex flexDir="column" gap="8px">
      <Flex justifyContent="space-between">
        <CollapsibleToggle
          label="More options"
          data-testid="lineItemEditor.moreOptions"
          isToggled={isVisible}
          onToggle={newState => setIsVisible(newState)}
        />

        {toggles && <Flex gap="8px">{toggles}</Flex>}
      </Flex>
    </Flex>

    <CollapsibleArea isVisible={isVisible} innerMarginTop="16px">
      <Flex gap="16px" flexDir="column">
        {children}
      </Flex>
    </CollapsibleArea>
  </Flex>
)

const Group = ({ children }: PropsWithChildren) => (
  <Flex flexDir="column" gap="8px">
    {children}
  </Flex>
)

const ToggleField = ({
  label,
  children,
  isVisible,
  setIsVisible,
  ...checkboxProps
}: {
  label: string
  children: ReactNode
  isVisible: boolean
  setIsVisible: (value: boolean) => void
} & CheckboxProps) => (
  <Box>
    <Checkbox
      id={label.toLowerCase().replace(/ /g, '-')}
      label={label}
      isChecked={isVisible}
      onChange={e => setIsVisible(e.target.checked)}
      {...checkboxProps}
    />
    <CollapsibleArea isVisible={isVisible} innerMarginTop="8px">
      {children}
    </CollapsibleArea>
  </Box>
)

export const SecondaryOptions = Object.assign(SecondaryOptionsComponent, {
  Group,
  ToggleField
})
